export default __webpack_public_path__ + "static/8-d5a88f020f33987793806ab8fb76c886.png";